import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { provideHooks } from "redial";
import { fetchSearch } from "../../state/modules/search";
import { setPageName } from "../../state/modules/page/actions";
import { getIsNewSearch } from "../../state/modules/search/selectors";
import { getMvtParams } from "../../state/modules/featureToggles/selectors";
import SearchPage from "../../components/SearchPage";

export function mapStateToProps(state) {
  return {
    mvtParams: getMvtParams(state)
  };
}

/* istanbul ignore next */
export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setPageName
    },
    dispatch
  );
}

const isValidSearch = location => location?.query?.q?.trim().length > 0;

export const hooks = {
  fetch: ({ dispatch, location, store, uuid, xSiteOrigin }) => {
    if (isValidSearch(location)) {
      if (!getIsNewSearch(store.getState())) {
        return;
      }

      return dispatch(fetchSearch(uuid, xSiteOrigin));
    }
  }
};

export default provideHooks(hooks)(
  connect(mapStateToProps, mapDispatchToProps)(SearchPage)
);
